import React from 'react';
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";

/**
 * Display a list of components (representing entities) and allow switching between them
 */
export default class EntitySelector extends React.Component {
  
  static propTypes = {
    entityIDList: ImmutablePropTypes.list.isRequired,
    selectedEntityID: PropTypes.any.isRequired,
    onSelectEntity: PropTypes.func.isRequired,
    children: PropTypes.func.isRequired,
    cssBlockName: PropTypes.string,
    loop: PropTypes.bool
  }
  
  static defaultProps = {
    loop: true
  }
  
  getEntityCount() {
    return this.props.entityIDList.size;
  }
  
  /**
   * @returns {number} index of the entity with the given ID
   */
  getEntityIndex(entityID) {
    return this.props.entityIDList.indexOf(entityID);
  }
  
  /**
   * @returns {boolean}
   */
  canSelectPrevious() {
    const hasMultipleEntities = this.getEntityCount() > 1;
    const canLoop = this.props.loop;
    const isFirstEntity = this.getEntityIndex(this.props.selectedEntityID) === 0;
    return hasMultipleEntities && (canLoop || !isFirstEntity);
  }
  
  /**
   * @returns {boolean}
   */
  canSelectNext() {
    const entityCount = this.getEntityCount();
    const hasMultipleEntities = entityCount > 1;
    const canLoop = this.props.loop;
    const isLastEntity = this.getEntityIndex(this.props.selectedEntityID) === (entityCount - 1);
    return hasMultipleEntities && (canLoop || !isLastEntity);
  }
  
  selectPreviousEntity = () => {
    if (this.canSelectPrevious()) {
      const { entityIDList, selectedEntityID } = this.props;
      const previousEntityVirtualIndex = this.getEntityIndex(selectedEntityID) - 1;
      const previousEntityRealIndex = previousEntityVirtualIndex % this.getEntityCount();
      const previousEntityID = entityIDList.get(previousEntityRealIndex);
      this.props.onSelectEntity(previousEntityID);
    }
  }

  selectNextEntity = () => {
    if (this.canSelectNext()) {
      const { entityIDList, selectedEntityID } = this.props;
      const nextEntityVirtualIndex = this.getEntityIndex(selectedEntityID) + 1;
      const nextEntityRealIndex = nextEntityVirtualIndex % this.getEntityCount();
      const nextEntityID = entityIDList.get(nextEntityRealIndex);
      this.props.onSelectEntity(nextEntityID);
    }
  }

  render() {
    const { entityIDList, selectedEntityID, cssBlockName } = this.props;
    return(
      <div className={cssBlockName}>
        <div className={`${cssBlockName}__button-container`}>
          {
            this.canSelectPrevious() ?
            <div className={`${cssBlockName}__previous`} onClick={this.selectPreviousEntity}></div> :
            null
          }
        </div>
        {
          entityIDList.map(entityID => {
            const isSelected = entityID === selectedEntityID;
            const cssElementName = `${cssBlockName}__item`;
            return (
              <EntitySelectorItem key={entityID} isSelected={isSelected} cssElementName={cssElementName}>
                { this.props.children(entityID) }
              </EntitySelectorItem>
            );
          })
        }
        <div className={`${cssBlockName}__button-container`}>
          {
            this.canSelectNext() ?
            <div className={`${cssBlockName}__next`} onClick={this.selectNextEntity}></div> :
            null
          }
        </div>
      </div>
    )
  }
}

/**
 * Wrap rendered entities in CSS classes for selected or unselected
 */
class EntitySelectorItem extends React.Component {
  
  static propTypes = {
    isSelected: PropTypes.bool.isRequired,
    cssElementName: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired
  }
  
  render() {

    const { cssElementName, isSelected, children } = this.props;
    
    const classNames = [ cssElementName ];
    if (isSelected) {
      classNames.push(cssElementName + "--selected");
    } else {
      classNames.push(cssElementName + "--unselected");
    }

    return <div className={classNames.join(" ")}>{children}</div>;

  }
}



// WEBPACK FOOTER //
// ./src/components/EntitySelector.js